import FullWidthLayout from "@/layouts/FullWidthLayout";
import KNearMissReportsTable from "kinnect-front/KSafety/NearMisses/KNearMissReportsTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { SafetyNearMissReport } from "kinnect-models";
import { VCard, VSheet } from "vuetify/lib";
import { debounce } from "kinnect-helpers";

export default {
	name: "SafetyNearMissReportsPage",

	metaInfo: { title: "Safety - Near Miss Reports" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		reports: [],
		search: "",
		searchReports: []
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_safety_near_miss_reports" ) ) {
				return {
					icon: "add_circle",
					text: "File Near Miss Report",
					to: { name: "safetyNearMissAdd" },
					tooltip: "File a new near miss / unsafe practice report"
				};
			}
		},

		numReports() {
			return this.reports.length;
		},

		displayedReports() {
			if ( this.search ) {
				return this.searchReports;
			}

			return this.reports;
		}
	},

	watch: {
		numReports( numReports ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numReports} reports` );
		},

		search() {
			this.fetchSearchResults();
		}
	},

	methods: {
		fetchSearchResults: debounce( async function() {
			if ( this.search ) {
				const queryWhenCallStarted = this.search;

				const reports = await SafetyNearMissReport
				.custom( "safety/near-miss-reports/search" )
				.params( { query: queryWhenCallStarted } )
				.get();

				if ( this.search === queryWhenCallStarted ) {
					this.searchReports = reports;
				}
			} else {
				this.searchReports = [];
			}
		}, 500 ),

		async fetchReports() {
			this.reports = await SafetyNearMissReport.get();
		},

		async fetch() {
			await this.fetchReports();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KNearMissReportsTable
					items={this.displayedReports}
					loading={this.$wait.is( "get near miss reports" )}
					search={this.search}
				></KNearMissReportsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
